// LIST
export const FETCH_HOME_GROUP_ADMINS = "app/Admin/FETCH_HOME_GROUP_ADMINS";
export const FETCH_HOME_GROUP_ADMINS_SUCCESS =
  "app/Admin/FETCH_HOME_GROUP_ADMINS_SUCCESS";
export const FETCH_HOME_GROUP_ADMINS_FAILURE =
  "app/Admin/FETCH_HOME_GROUP_ADMINS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/Admin/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/Admin/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/Admin/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_HOME_GROUP_ADMIN = "app/Admin/ADD_HOME_GROUP_ADMIN";
export const ADD_HOME_GROUP_ADMIN_SUCCESS =
  "app/Admin/ADD_HOME_GROUP_ADMIN_SUCCESS";
export const ADD_HOME_GROUP_ADMIN_FAILURE =
  "app/Admin/ADD_HOME_GROUP_ADMIN_FAILURE";
// EDIT
export const EDIT_HOME_GROUP_ADMIN = "app/Admin/EDIT_HOME_GROUP_ADMIN";
export const EDIT_HOME_GROUP_ADMIN_SUCCESS =
  "app/Admin/EDIT_HOME_GROUP_ADMIN_SUCCESS";
export const EDIT_HOME_GROUP_ADMIN_FAILURE =
  "app/Admin/EDIT_HOME_GROUP_ADMIN_FAILURE";
// DELETE
export const DELETE_HOME_GROUP_ADMIN = "app/Admin/DELETE_HOME_GROUP_ADMIN";
export const DELETE_HOME_GROUP_ADMIN_SUCCESS =
  "app/Admin/DELETE_HOME_GROUP_ADMIN_SUCCESS";
export const DELETE_HOME_GROUP_ADMIN_FAILURE =
  "app/Admin/DELETE_HOME_GROUP_ADMIN_FAILURE";
//
export const OPEN_ADMIN_ADD_MODAL = "app/Admin/OPEN_ADMIN_ADD_MODAL";
export const CLOSE_ADMIN_ADD_MODAL = "app/Admin/CLOSE_ADMIN_ADD_MODAL";
//
export const OPEN_ADMIN_EDIT_MODAL = "app/Admin/OPEN_ADMIN_EDIT_MODAL";
export const CLOSE_ADMIN_EDIT_MODAL = "app/Admin/CLOSE_ADMIN_EDIT_MODAL";
export const SET_ADMIN_SUCCESS = "app/Admin/SET_ADMIN_SUCCESS";
export const SET_ADMIN_FAILURE = "app/Admin/SET_ADMIN_FAILURE";

// GET CHECK MASTER ADMIN
export const GET_CHECK_MASTER_ADMIN = "app/Admin/GET_CHECK_MASTER_ADMIN";
export const GET_CHECK_MASTER_ADMIN_SUCCESS =
  "app/Admin/GET_CHECK_MASTER_ADMIN_SUCCESS";
export const GET_CHECK_MASTER_ADMIN_FAILURE =
  "app/Admin/GET_CHECK_MASTER_ADMIN_FAILURE";

export const TOGGLE_INVITE_MODAL = "app/Admin/TOGGLE_INVITE_MODAL";

export const INVITE_ADMIN = "app/Admin/INVITE_ADMIN";
export const INVITE_ADMIN_SUCCESS = "app/Admin/INVITE_ADMIN_SUCCESS";
export const INVITE_ADMIN_FAILURE = "app/Admin/INVITE_ADMIN_FAILURE";
